<template>
  <div>
    <v-toolbar
      height="60"
      color="teal darken-1"
      app
      center
      class="baner"
    >
      <v-btn
        color="green"
        class="white--text"
        href="/inicio"
      >
        INICIO
        <v-icon
          right
          dark
        >
          home
        </v-icon>
      </v-btn>
      <v-spacer />
      <h2 class="center white--text">
        UNIVERSIDAD NACIONAL INTERCULTURAL DE QUILLABAMBA
      </h2>
      <v-spacer />
    </v-toolbar>
    <br>
    <div class="titulo">
      <h2>Modalidades de Ingreso</h2>
    </div>
    <v-layout
      row
      wrap
    >
      <v-spacer />
      <v-flex
        xs12
        sm3
      >
        <v-card>
          <!-- //{{{ -->
          <v-img
            src="http://www.elregionalpiura.com.pe/images/Fotografias/2019/Marzo_2019/examen_admision_universidad_de_frontera_1.jpg"
            aspect-ratio="2.75"
          />
          <v-card-title primary-title>
            <div class="extraordinario">
              <h3 class="headline mb-0">
                MODALIDAD EXTRAORDINARIO
              </h3>
              <div>{{ card_text }}</div>
              <v-list three-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="deep-orange">
                      filter_1
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Los estudiantes del CEPRE UNIQ.
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="deep-orange">
                      filter_2
                    </v-icon>
                  </v-list-tile-action>
                  Primeros y Segundos Puestos del año inmediato anterior de
                  las Instituciones Educativas del nivel secundario.
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="deep-orange">
                      filter_3
                    </v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    Deportistas destacados, acreditados como tales por el
                    Instituto Peruano del Deporte (IPD).
                  </v-list-tile-content>
                </v-list-tile>
                <v-expansion-panel>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div>ver mas</div>
                    </template>
                    <v-card>
                      <v-card-text>
                        <br>
                        <v-list-tile-action>
                          <v-icon color="deep-orange">
                            filter_4
                          </v-icon>
                        </v-list-tile-action>
                        <br>
                        <p>
                          Personas con Discapacidad según Ley Nº 29973, tienen
                          derecho a una reserva del 5% de las vacantes ofrecidas
                          en sus procedimientos de admisión.
                        </p>
                        <br>
                        <v-list-tile-action>
                          <v-icon color="deep-orange ">
                            filter_5
                          </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <p>
                            Víctimas del Terrorismo y Programa Integral de
                            Reparaciones Ley Nº 28592 y Ley N° 27277.
                          </p>
                        </v-list-tile-content>
                        <span>
                          <v-list-tile-action>
                            <v-icon color="deep-orange">filter_6</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <p>
                              Estudiantes provenientes de los pueblos
                              originarios
                            </p>
                          </v-list-tile-content>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-list>
            </div>
          </v-card-title>
        </v-card> <!-- //}}} -->
      </v-flex>
      <v-spacer />
      <v-flex
        xs12
        sm3
      >
        <v-card>
          <!-- //{{{ -->
          <v-img
            src="http://www.elregionalpiura.com.pe/images/Fotografias/2019/Marzo_2019/examen_admision_universidad_de_frontera_1.jpg"
            aspect-ratio="2.75"
          />
          <v-card-title
            primary-title
            class="card-title"
          >
            <div class="ordinario">
              <h3 class="headline mb-0">
                MODALIDAD ORDINARIO
              </h3>
              <div>{{ card_text }}</div>
            </div>
          </v-card-title>
          <v-list
            three-line
            class="card-modality"
          >
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="green">
                  filter_1
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                Egresados del nivel secundario.
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="green">
                  filter_2
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                Egresados de la Educación Básica Alternativa.
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="green">
                  filter_3
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                Estudiantes que no han logrado ingresar a través de la
                modalidad extraordinaria.
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card> <!-- //}}} -->
      </v-flex>
      <v-spacer />
      <v-flex
        xs12
        sm3
      >
        <v-card>
          <!-- //{{{ -->
          <v-img
            src="http://www.elregionalpiura.com.pe/images/Fotografias/2019/Marzo_2019/examen_admision_universidad_de_frontera_1.jpg"
            aspect-ratio="2.75"
          />
          <v-card-title primary-title>
            <div class="ordinario">
              <h3 class="headline mb-0">
                MODALIDAD CONCURSO DE ADMISIÓN PARA ESTUDIANTES DEL QUINTO AÑO
                DE SECUNDARIA
              </h3>
              <div>{{ card_text }}</div>
            </div>
          </v-card-title>
          <v-list
            three-line
            class="card-modality"
          >
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="green">
                  filter_1
                </v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                Quienes se encuentren cursando el quinto año de educación secundaria en el presente año
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card> <!--//}}} -->
      </v-flex>
      <v-spacer />
    </v-layout>
  </div>
</template>
<script>
export default {
  data () {
    return {
      card_text: 'En esta modalidad pueden postular:'
    }
  }
}
</script>
<style>
.extraordinario {
  background-color: white;
  color: #ff5722;
}
.ordinario {
  background-color: white;
  color: green;
}
.titulo {
  margin-top: 10px;
  margin-block: 10px;
  text-align: center;
  align-items: center;
  align-content: center;
  padding-right: 1.4rem;
  font-size: 25px;
  color: #00695c;
}
.center {
  display: flex;
  align-items: center;
  padding-right: 1.4rem;
  font-size: 25px;
  margin-inline-start: 20px;
}
.card-modality {
  height: 280px;
}
.card-title {
  height: 125px;
}
@media only screen and (max-width: 600px) {
  .center {
    display: flex;
    align-items: center;
    padding-right: 0.5em;
    font-size: 10px;
    margin-inline-start: 20px;
  }
}
</style>
